const RoleActionEnum = {
  Role: 100,
  RoleList: 101,
  RoleCreate: 102,
  RoleUpdate: 103,
  RoleDelete: 104,

  User: 150,
  UserList: 151,
  UserCreate: 152,
  UserUpdate: 153,
  UserDelete: 154,

  CategoryBrandModel: 200,
  CategoryBrandModelList: 201,
  CategoryBrandModelCreate: 202,
  CategoryBrandModelUpdate: 203,
  CategoryBrandModelDelete: 204,

  Vehicle: 250,
  VehicleList: 251,
  VehicleCreate: 252,
  VehicleUpdate: 253,
  VehicleDelete: 254,

  Expert: 300,
  ExpertList: 301,
  ExpertCreate: 302,
  ExpertUpdate: 303,
  ExpertDelete: 304,

  Service: 350,
  ServiceList: 351,
  ServiceCreate: 352,
  ServiceUpdate: 353,
  ServiceDelete: 354,

  Customer: 400,
  CustomerList: 401,
  CustomerCreate: 402,
  CustomerUpdate: 403,
  CustomerDelete: 404,

  Financial: 450,
  FinancialList: 451,
  FinancialCreate: 452,
  FinancialUpdate: 453,
  FinancialDelete: 454,
};

export default RoleActionEnum;